module.exports = __webpack_public_path__ + "img/port-of-destination.3c056fd9.svg";